import { NavBar, NavbarWidget } from 'shared/components/__FOX__/NAV/src'
import { LogoName } from './DeziiignNavbar'
import styled, { useTheme } from 'styled-components'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useIsMobile } from '@brg/ui'
import WPOnlinesIcon from 'shared/icons/onlines/WPOnlinesIcon'
import TGOnlinesIcon from 'shared/icons/onlines/TGOnlinesIcon'
import { InfoIcon } from 'shared/icons/onlines/InfoIcon'
import almatylogo from 'shared/pages/commdesign/images/icons/almatylogo.svg'
import almatydesign from 'shared/pages/commdesign/images/icons/ALMATY_ART_SCHOOL.svg'
import {useGetFilteredTabs} from "../components/navigationSystem/useGetFilteredTabs";

const CommdesignLogo = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 100;

    span {
        display: block;
        font-size: 18px;
        line-height: 18px;
    }
`

const CommdesignNavIconWrapper = styled.a`
    height: 28px;
    width: 28px;

    svg {
        height: 28px;
        width: 28px;
    }
`

const Button = styled.a`
    background-color: #2d2f33;
    color: white;
    font-weight: 600;
    font-size: 1rem;
    letter-spacing: 0.3px;
    text-align: center;
    width: 150px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;

    font-family: "HSE Sans", sans-serif;
    
    &:hover {
        color: white;
    }
`

const AlmatyDesignLogo = styled.div`
    width: 290px;
    height: 30px;
    background: url(${almatydesign});
    background-size: contain;
    background-position-y: 1px;
    background-repeat: no-repeat;
`

export const CommdesignNavbar = () => {
    const theme = useTheme()
    const history = useHistory()
    const { t, i18n } = useTranslation()
    const isMobile = useIsMobile()
    const items = useGetFilteredTabs()

  return (
    <NavBar
    theming={{
        zIndex: 99999,
        backgroundColor: theme.navigationBar.backgroundColor,
        borderBottomColor: theme.navigationBar.borderBottomColor,
        backgroundScrolling: theme.navigationBar.backgroundScrollingColor,
        boxShadow: theme.navigationBar.boxShadow,
    }}
    logo={<LogoName> 
            <CommdesignLogo onClick={() => history.push("/school/commdesign/2")}>
                <AlmatyDesignLogo/>
            </CommdesignLogo> 
        </LogoName>
        }
    // Logo via SVG places here
    onLogoClick={() => history.push('/')}
    sections={[
        // Left section ------------------------------------------------------------------------>
        [
          <NavbarWidget.Links
            theming={theme.navigationBar.links}
            items={items}
          />
        ],
        [
        ],
        [
            ...(isMobile ? [
                <CommdesignNavIconWrapper href='/school/commdesign/1'>
                    <InfoIcon/>
                </CommdesignNavIconWrapper>,
            ] : [
            ]),
            <CommdesignNavIconWrapper href='https://wa.me/message/WEDGXNMC6Z7SH1' target='_blank'>
                <WPOnlinesIcon />
            </CommdesignNavIconWrapper>,
            <CommdesignNavIconWrapper href='https://t.me/deziiignproject' target='_blank'>
                <TGOnlinesIcon/>
            </CommdesignNavIconWrapper>,
            ...(isMobile ? [] : [
                <Button lang={i18n.language} href="https://calendly.com/deziiign/free30" target="_blank">
                    Как записаться
                </Button>,
            ])
        ]
    ]}
/>
  )
}
import { NavBar, NavbarWidget } from 'shared/components/__FOX__/NAV/src'
import { LogoName } from './DeziiignNavbar'
import styled, { useTheme } from 'styled-components'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useIsMobile } from '@brg/ui'
import WPOnlinesIcon from 'shared/icons/onlines/WPOnlinesIcon'
import TGOnlinesIcon from 'shared/icons/onlines/TGOnlinesIcon'
import { InfoIcon } from 'shared/icons/onlines/InfoIcon'
import almatylogo from 'shared/pages/commdesign/images/icons/almatylogo.svg'
import almatydesign from 'shared/pages/commdesign/images/icons/ALMATY_ART_SCHOOL.svg'
import {useGetFilteredTabs} from "../components/navigationSystem/useGetFilteredTabs";

const CommdesignLogo = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 100;

    span {
        display: block;
        font-size: 18px;
        line-height: 18px;
    }
`

const CommdesignNavIconWrapper = styled.a`
    height: 28px;
    width: 28px;

    svg {
        height: 28px;
        width: 28px;
    }
`

const Button = styled.a`
    background-color: #2d2f33;
    color: white;
    font-weight: 600;
    font-size: 1rem;
    letter-spacing: 0.3px;
    text-align: center;
    width: 150px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;

    font-family: "HSE Sans", sans-serif;
    
    &:hover {
        color: white;
    }
`

const AlmatyDesignLogo = styled.div`
    width: 290px;
    height: 30px;
    background: url(${almatydesign});
    background-size: contain;
    background-position-y: 1px;
    background-repeat: no-repeat;
`

export const CommdesignNavbar = () => {
    const theme = useTheme()
    const history = useHistory()
    const { t, i18n } = useTranslation()
    const isMobile = useIsMobile()
    const items = useGetFilteredTabs()

  return (
    <NavBar
    theming={{
        zIndex: 99999,
        backgroundColor: theme.navigationBar.backgroundColor,
        borderBottomColor: theme.navigationBar.borderBottomColor,
        backgroundScrolling: theme.navigationBar.backgroundScrollingColor,
        boxShadow: theme.navigationBar.boxShadow,
    }}
    logo={<LogoName> 
            <CommdesignLogo onClick={() => history.push("/school/commdesign/2")}>
                <AlmatyDesignLogo/>
            </CommdesignLogo> 
        </LogoName>
        }
    // Logo via SVG places here
    onLogoClick={() => history.push('/')}
    sections={[
        // Left section ------------------------------------------------------------------------>
        [
          <NavbarWidget.Links
            theming={theme.navigationBar.links}
            items={items}
          />
        ],
        [
        ],
        [
            ...(isMobile ? [
                <CommdesignNavIconWrapper href='/school/commdesign/1'>
                    <InfoIcon/>
                </CommdesignNavIconWrapper>,
            ] : [
            ]),
            <CommdesignNavIconWrapper href='https://wa.me/message/WEDGXNMC6Z7SH1' target='_blank'>
                <WPOnlinesIcon />
            </CommdesignNavIconWrapper>,
            <CommdesignNavIconWrapper href='https://t.me/deziiignproject' target='_blank'>
                <TGOnlinesIcon/>
            </CommdesignNavIconWrapper>,
            ...(isMobile ? [] : [
                <Button lang={i18n.language} href="https://calendly.com/deziiign/free30" target="_blank">
                    Как записаться
                </Button>,
            ])
        ]
    ]}
/>
  )
}
